import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const STORE_MESSAGE = 'STORE_MESSAGE';
export const STORE_MESSAGE_SUCCESS = 'STORE_MESSAGE_SUCCESS';
export const STORE_MESSAGE_FAIL = 'STORE_MESSAGE_FAIL';
export const STORE_MESSAGE_RESET = 'STORE_MESSAGE_RESET';

export const storeMessage = (params) => {
  return {
    type: STORE_MESSAGE,
    params,
  };
};

export const storeMessageSuccess = (response) => {
  return {
    type: STORE_MESSAGE_SUCCESS,
    response,
  };
};

export const storeMessageFail = (response) => {
  return {
    type: STORE_MESSAGE_FAIL,
    response,
  };
};

export const storeMessageReset = () => {
  return {
    type: STORE_MESSAGE_RESET
  };
};

export const storeMessageApi = (data) => {
  return (dispatch) => {
    dispatch(storeMessage());
    axios
      .post(`${config.api.base_url}/voice-assistance/message/store`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const messageData = response.data;
        dispatch(storeMessageSuccess(messageData));
      })
      .catch((error) => {
        const errorMsg = error.response
          ? error.response.data
          : error.message;
        dispatch(storeMessageFail(errorMsg));
      });
  };
}; 